export function getCachepieseschimb ({ state, commit }, { search, page }) {
  return new Promise((resolve, reject) => {
    axiosInstance.get('/v1/cachepieseschimb', { params: { search, page } })
      .then((response) => {
        if (response.data.cachepieseschimb) {
          commit('setCachepieseschimb', response.data.cachepieseschimb)
        }

        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function createCachepieseschimb ({ state, commit }) {
  return new Promise((resolve, reject) => {
    axiosInstance.post('/v1/cachepieseschimb')
      .then((response) => {
        if (response.data.cachepieseschimb) {
          commit('setCachepieseschimb', response.data.cachepieseschimb)
        }
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function updateCachepieseschimb ({ state, commit }, itemkey) {
  return new Promise((resolve, reject) => {
    if (itemkey) {
      axiosInstance.put('/v1/cachepieseschimb/' + itemkey)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    } else {
      reject(new Error('No itemkey'))
    }
  })
}

export function deleteCachepieseschimb ({ state, commit }) {
  return new Promise((resolve, reject) => {
    axiosInstance.delete('/v1/cachepieseschimb/all')
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}
